export const qs = location.search
            .substring(1)
            .split("&")
            .reduce(function (acc, paramRaw) {
              var param = paramRaw.split("=");
              acc[param[0]] = param[1];
              delete acc[""];
              return acc;
            }, {});
            
export default qs;